// Ambient slot v hlavičce okna (řádek 2, `pwm-titlerow`). PhoenixWindow vyrenderuje cílový element
// a poskytne ho přes kontext obsahu vrstvy; komponenta detailu do něj portáluje podtitulek + libovolný
// obsah přes `WindowHeaderExtras`. `null` = mimo okno / chromeless (list panel) → portál nic nevykreslí.

import { createContext, useContext } from 'react';

export const WindowHeaderSlotContext = createContext<HTMLElement | null>(null);

/** Vrátí cílový element hlavičky aktuálního okna (nebo `null` mimo okno / u chromeless). */
export function useWindowHeaderSlot(): HTMLElement | null {
  return useContext(WindowHeaderSlotContext);
}
